import React from "react";
import ReportTotalEconomic from "./ReportTotalEconomic";

const listdata = [
  { value: "mda_expenditure_by_eco", title: "Expenditure by Economic" },
];

function ExpenditureByEconomic() {
  return (
    <ReportTotalEconomic
      type="mda_expenditure_by_eco"
      title="Expenditure by Economic"
      route="/reports"
      options={listdata}
    />
  );
}

export default ExpenditureByEconomic;
